import React, { useState } from 'react';
import '../../components/PrivatePage/private-page.css';
import CandleChart from './CandleChart';
import TechnicalAnalysisWidget from './TechnicalAnalysisWidget';

const TABS = [
  { id: 'chart', label: 'Chart' },
  { id: 'technicals', label: 'Technicals' },
];

/**
 * props:
 * - symbol
 */
function ChartPanel(props) {
  const [activeTab, setActiveTab] = useState('chart');

  return (
    <div className="private-page-card chart-panel">
      <div className="chart-panel-header d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
        <div>
          <h2 className="h5 mb-1 text-slate-800">{props.symbol}</h2>
          <p className="text-muted small mb-0">Market analysis and chart tools</p>
        </div>
        <ul className="chart-panel-tabs nav nav-pills" role="tablist">
          {TABS.map((tab) => (
            <li className="nav-item" key={tab.id} role="presentation">
              <button
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`nav-link chart-panel-tab ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="chart-panel-content">
        {activeTab === 'chart' && <CandleChart symbol={props.symbol} />}
        {activeTab === 'technicals' && <TechnicalAnalysisWidget symbol={props.symbol} />}
      </div>
    </div>
  );
}

export default ChartPanel;